import { Controller } from "stimulus"

export default class extends Controller {

	static targets = ["modal", "saveButton", "declarationCheckbox"]

	connect() {
		// Store which declarations have been completed
		if (!this.element.dataset.completedDeclarations) {
			this.element.dataset.completedDeclarations = JSON.stringify({})
		}
	}

	closeModal(e) {
		e.preventDefault()
		// Close all modals
		this.modalTargets.forEach(modal => {
			modal.classList.remove("is-active")
		})
	}

	showModal(e) {
		e.preventDefault()
		const index = e.currentTarget.dataset.index
		const modalId = `health-declaration-modal-${index}`
		const modal = document.getElementById(modalId)
		if (modal) {
			modal.classList.add("is-active")
		}
	}

	enableSave(e) {
		// Find the save button in the same modal as the checkbox
		const modal = e.target.closest('.modal')
		const saveButton = modal.querySelector('[data-target="health-declarations.saveButton"]')
		if (e.target.checked) {
			saveButton.disabled = false
		} else {
			saveButton.disabled = true
		}
	}

	saveDeclaration(e) {
		e.preventDefault()
		const index = e.currentTarget.dataset.index
		const modalId = `health-declaration-modal-${index}`
		const modal = document.getElementById(modalId)

		// Mark this declaration as completed
		const completedDeclarations = JSON.parse(this.element.dataset.completedDeclarations)
		completedDeclarations[index] = true
		this.element.dataset.completedDeclarations = JSON.stringify(completedDeclarations)

		// Update the button to show completion
		const triggerButton = document.querySelector(`[data-action="health-declarations#showModal"][data-index="${index}"]`)
		if (triggerButton) {
			triggerButton.classList.remove('is-warning')
			triggerButton.classList.add('is-success')
			triggerButton.innerHTML = 'Health declaration completed ✓'
		}

		// Close modal
		modal.classList.remove("is-active")
	}
}
